import { render } from "./RenewCertificate.vue?vue&type=template&id=4e34ca6a"
import script from "./RenewCertificate.vue?vue&type=script&lang=js"
export * from "./RenewCertificate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__